import {
  accountNumberRegExp,
  alphabetsRegExp,
  ifscRegExp,
  panCardRegExp,
} from '@zet/constants/regex'
import { i18n } from '@zet/localization'
import { z } from 'zod'

export const BankDetailsSchema = () => {
  return z
    .object({
      panCard: z
        .string()
        .regex(panCardRegExp, { message: i18n.t('errorPanCard') }),
      bankName: z
        .string()
        .min(3, {
          message: i18n.t('errorBankNameMin3'),
        })
        .regex(alphabetsRegExp, {
          message: i18n.t('errorBankAccountName'),
        }),
      accountNumber: z.string().regex(accountNumberRegExp, {
        message: i18n.t('errorAccountNumber'),
      }),
      ifscCode: z
        .string()
        .regex(ifscRegExp, { message: i18n.t('errorIfscCode') }),
    })
    .required()
}
